<section class="bg-[#EAEAEA]">

  <div class="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
    <h2 class="mb-8 text-8xl tracking-tight font-bold text-[#1F2125] font-tektur mt-14" i18n>FAQ</h2>
    <div class="flex pt-8 text-left lg:w-[58%]">
      <div class="[&>div>h3]:font-tektur [&>div>p]:font-tektur [&>div>h3]:font-semibold [&>div>h3]:text-3xl [&>div>p]:text-mainColor [&>div>h3]:text-mainColor">
        <div class="mb-10">
          <h3 class="flex items-center mb-4">
            I’d like to donate or sell my own vehicle, how do I do it?
          </h3>
          <p>
            You can donate car to Ukraine with us. Please fill up the form and we’ll get back to
            you within 24 hours. We focus mainly on pickup trucks and 4x4 cars, but other means of transportation such
            as vans, and civilian cars are accepted as soldiers also move around and have different tasks for which
            wheels are needed.
          </p>
        </div>
        <div class="mb-10">
          <h3 class="flex items-center mb-4">
            What vehicles do you need?
          </h3>
          <p class="flex gap-4 flex-col">
            We focus on mobile combat groups who need 4-wheel drive diesel trucks with 2.0l engines or more. These
            are some of the best options: Toyota Hilux / Tundra, Mitsubishi L200, Ford Ranger, Nissan Navara/KingCab,
            Isuzu D-Max, Mazda BT-50 / Mazda B2500.<br>
            <span >
              Besides pickup trucks, 4x4 cars and vans as well as simple civilian vehicles are required
              too for various missions, e.g. aid delivery, food supplies, etc.
            </span>
          </p>
        </div>
        <div class="mb-10">
          <h3 class="flex items-center mb-4">
            Can I have my car back after the war is over?
          </h3>
          <p>
            We cannot guarantee it will be usable after Ukraine puts end to Russian aggression. The car will be imported
            without any “import duties” into Ukraine, since its owner will be officially Ukrainian Armed Forces.
          </p>
        </div>
        <div class="mb-10">
          <h3 class="flex items-center mb-4">
            Where do I see the results of your campaign?
          </h3>
          <p>
            We are publishing our activity results on
            <a class="underline" href="https://x.com/carforukraine"
               target="_blank"
               title="Link to Car for Ukraine Twitter Page"
            >
              Twitter
            </a>,
            <a class="underline" href="https://www.instagram.com/car4ukraine.com_official/"
               target="_blank"
               title="Link to Car for Ukraine Instagram Page"
            >
              Instagram
            </a> and
            <a class="underline" href="https://www.facebook.com/car4ukraine"
               target="_blank"
               title="Link to Car for Ukraine Facebook Page"
            >
              Facebook</a>.<br>
            Follow us to stay up-to-date. We commit to provide the highest level of transparency.<br>
            At the same time, we ask you to be patient, as it is not a movie but a war. Fighters on the frontline cannot
            take pictures as the main priority, as they have their lives at risk all the time.
          </p>
        </div>
        <div class="mb-10">
          <h3 class="flex items-center mb-4">
            Why should I trust you?
          </h3>
          <p>
            We are a group of Ukrainian volunteers. We have our regular jobs, we donate our funds, but want “help to help”.<br>
            We are in Ukraine, in EU, in USA and other parts of the world. We interact regularly frontline military and
            defense units bases in the East and South side.
          </p>
        </div>
        <div class="mb-10">
          <h3 class="flex items-center mb-4">
            How to cancel or make changes to a regular monthly donation?
          </h3>
          <p>
            Once you've made a donation at donorbox campaign page you automatically create an account at Donorbox and all
            the details are sent to your email address. So please check your inbox looking for messages from Donorbox and
            follow their instructions. If it doesn't work, or you have any other issues, please send us an email to
            <a class="font-bold" href="mailto:info@car4ukraine.com">{{ infoMail }}</a> indicating your email address and / or full name with details of your inquiry.
          </p>
        </div>
      </div>
    </div>
  </div>

</section>
